import React from "react";
import DirectoryMenu from "../../components/directory/DirectoryMenu";
import './css/Homepage.css';

const Homepage = () => {
    return (
        <div className="homepage">    
            <DirectoryMenu />
        </div>
    )
}

export default Homepage;